export const SEARCH_MIN_LENGTH = 3
